// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"368":"d1c9d921","811":"72fe27e1"}[chunkId] + ".js";
};